angular.module('impactx.panel').directive('ixLotPreviewPanel', LotPreviewPanelDirective);

function LotPreviewPanelDirective() {
    return {
        restrict: 'EA',
        controller: 'LotPreviewPanelCtrl',
        controllerAs: 'lotPreviewPanelCtrl',
        scope: true,
        bindToController: {
            name: "=",
            image: "=",
            contractType: "=",
            trns: "=",
            contractNo: '@',
            isNabe: '=',
            siteNumber: "="
        },
        templateUrl: 'shared/panel/templates/lot.preview.panel.tmpl.html'
    }
}